import { Box, Typography, Skeleton } from '@mui/material';
import React from 'react';

export default function LoadingGrid(): React.ReactElement {
    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '31rem',
                flexDirection: 'column',
                gap: '1em',
            }}
        >
            <Typography variant="h5" sx={{ width: '20%' }}>
                <Skeleton />
            </Typography>
            <Typography variant="h5" sx={{ width: '15%' }}>
                <Skeleton />
            </Typography>
            <Skeleton
                variant="rectangular"
                sx={{ width: '100%', height: '29rem', borderRadius: '4px' }}
            />
        </Box>
    );
}
